import { get } from 'lodash-es';
import PageHeader from '@/mixins/page-header';

const DEFAULT_DESCRIPTION =
  'Große Auswahl an Handys & Smartphones, Tablets und Zubehör. Geprüfte Sicherheit ✓ Schnelle Lieferzeiten ✓ Jetzt entdecken und bestellen!';

const DEFAULT_IMAGE_PATH = '';

export default {
  mixins: [PageHeader],
  computed: {
    title() {
      return get(this.pageMeta, 'title'); // <1>
    },
    tealiumType() {
      return get(this.pageMeta, 'type', 'theme.common'); // <2>
    },
    description() {
      return get(this.pageMeta, 'description'); // <3>
    },
    ogType() {
      return get(this.pageMeta, 'og.type', 'website'); // <4>
    },
    ogImagePath() {
      return get(this.pageMeta, 'og.image', DEFAULT_IMAGE_PATH); // <5>
    },
    ogDescription() {
      return get(this.pageMeta, 'og.description', DEFAULT_DESCRIPTION); // <6>
    },
    nexusDescription() {
      return get(this.pageMeta, 'exagon.description', this.description);
    },
    selfCanonical() {
      return get(this.pageMeta, 'canonical');
    },
  },
};
